import type {
  AnalyticsDailyStatsRequest,
  AnalyticsDailyStatsRow,
} from './types';

type RequestDailyStatsOptions = {
  signal?: AbortSignal;
};

const API_BASE = import.meta.env?.VITE_API_URL ?? '/api';
const API_TOKEN = import.meta.env?.VITE_API_TOKEN;

const buildApiUrl = (path: string): string => {
  const base = API_BASE.endsWith('/') ? API_BASE.slice(0, -1) : API_BASE;

  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
};

const getAuthToken = (): string | null => {
  if (typeof window === 'undefined') {
    return API_TOKEN ?? null;
  }

  return window.localStorage.getItem('auth_token') ?? API_TOKEN ?? null;
};

export const requestDailyStats = async (
  payload: AnalyticsDailyStatsRequest,
  options: RequestDailyStatsOptions = {},
): Promise<AnalyticsDailyStatsRow[]> => {
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };

  const token = getAuthToken();

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const requestInit: RequestInit = {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
    credentials: 'include',
  };

  if (options.signal) {
    requestInit.signal = options.signal;
  }

  const response = await fetch(buildApiUrl('/statistics/daily-stats'), requestInit);

  if (!response.ok) {
    const message = await response.text();
    throw new Error(
      message || `Request failed with status ${response.status.toString()}`,
    );
  }

  return (await response.json()) as AnalyticsDailyStatsRow[];
};
